import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';

export default class RuneInfoTable extends Component {
    render() {
        const {stats, slots, iLevel} = this.props;

        if((!slots || slots.length === 0 )) {
            return null;
        }

        const iLevelRow = iLevel ?
            <Table.Row key='iLevel'>
                <Table.Cell>
                    Required iLevel
                </Table.Cell>
                <Table.Cell textAlign="right">{iLevel}</Table.Cell>
            </Table.Row> : null;

        const slotsTableRows = slots.map((s,i) => {
            return (i === 0) ?
                <Table.Row key={`Slot ${s}`}>
                    <Table.Cell rowSpan={slots.length}>Slot</Table.Cell>
                    <Table.Cell textAlign="right">{s}</Table.Cell>
                </Table.Row> :
                <Table.Row key={`Slot ${s}`}>
                    <Table.Cell textAlign="right">{s}</Table.Cell>
                </Table.Row>
        });

        const statsTableRows = (stats) ?
            Object.keys(stats).map(s =>
                <Table.Row key={s}>
                    <Table.Cell>{s}</Table.Cell>
                    <Table.Cell textAlign="right">{stats[s]}</Table.Cell>
                </Table.Row>
            ) : null;

        return (
            <Table compact celled structured>
                <Table.Body>
                    {slotsTableRows}
                    {iLevelRow}
                    {statsTableRows}
                </Table.Body>
            </Table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/runes/RuneInfoTable.jsx